<template>
  <div class="my-radio">
   <div v-for="(item, index) in radioData" class="row" @click="change(item)" :key=index>
      <div :class="['radio', item.status ? 'radio-active' : 'radio-normal']"></div>
      <div class="label">{{ item.label }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'my-radio',
  data () {
    return {
    }
  },
  props: {
    radioData: {
      required: true
    },
    radioName: {
      required: true
    }
  },
  methods: {
    change (data) {
      // console.log(data)
      this.$emit('radioChange', data, this.radioName)
    }
  }
}
</script>

<style  lang="stylus" scoped>
  .my-radio
    text-align: left
    margin-left : 1rem
    .row
      margin-bottom: .4rem
      position: relative
      // margin-left : .03rem
      // float: left
      display: inline-block
      width: 100%
      line-height: .4rem
      color: #976e48
      font-size: .4rem
      cursor: pointer
      -webkit-tap-highlight-color:rgba(0,0,0,0);
      .radio
        margin-top: .02rem
        vertical-align: top
        display: inline-block
        width: 20px
        height: 20px
        background-size: 100%
        background-repeat: no-repeat
      .radio-active
        background-image: url('../../assets/images/radio-active.png')
      .radio-normal
        background-image: url('../../assets/images/radio-normal.png')
      .label, .input-container
        display: inline-block
        width: calc(100% - 24px - 15px)
      .input-container
        .text
          float: left
        .input
          padding: 0 0
          margin-left: 10px
          float: left
          width: calc(100% - 4em)
</style>



// WEBPACK FOOTER //
// src/servey/compoents/MyRadio.vue